import { ContractorContextProvider } from '@features/Contractor/ContractorContext'
import { ContractorTabsBar } from '@features/Contractor/components/ContractorTabsBar'
import { getContractorQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/contractor/$contractorId')({
  component: ContractorLayout,
  staticData: {
    breadcrumb: 'Entreprenør',
  },
})

const standaloneRoutes: {
  to: Parameters<ReturnType<typeof useMatchRoute>>[0]['to']
  fuzzy?: boolean
}[] = [
  { to: '/contractor/$contractorId/edit', fuzzy: true },
  { to: '/contractor/$contractorId/sendSMS', fuzzy: true },
  { to: '/contractor/$contractorId/employees/add', fuzzy: true },
  { to: '/contractor/$contractorId/employees/$employeeId/edit', fuzzy: true },
  { to: '/contractor/$contractorId/machines/add', fuzzy: true },
  { to: '/contractor/$contractorId/machines/$machineId/edit', fuzzy: true },
  { to: '/contractor/$contractorId/forest-crews/add', fuzzy: true },
  { to: '/contractor/$contractorId/forest-crews/$forestCrewId', fuzzy: true },
]

function ContractorLayout() {
  const { contractorId } = Route.useParams()
  const { data, isLoading, isError, refetch } = useQuery(getContractorQuery(contractorId))
  const matchRoute = useMatchRoute()

  const isStandalone = standaloneRoutes.some(({ to, fuzzy = false }) => matchRoute({ to, fuzzy }))

  const handleRefetch = () => {
    void refetch()
  }

  return (
    <ContractorContextProvider value={{ data, isLoading, isError, refetch: handleRefetch }}>
      {!isStandalone && <ContractorTabsBar />}
      <Outlet />
    </ContractorContextProvider>
  )
}
